import { ReasonCounted } from '@bofrak-backend/shared';
import { CheckedReasons } from './types';

export function unStringfy(str: any) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

export function capitalize(str: string) {
  return str.toLocaleLowerCase().charAt(0).toUpperCase() + str.slice(1);
}

export function formatDate(date: Date) {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().substr(2, 2);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function computeSelectedFetchReason(checkedReasons: CheckedReasons) {
  const reasons: ReasonCounted[] = [];
  if (checkedReasons.purchase) reasons.push(ReasonCounted.PURCHASE);
  if (checkedReasons.count) reasons.push(ReasonCounted.INVENTORY_COUNT);
  if (checkedReasons.correction)
    reasons.push(ReasonCounted.INVENTORY_CORRECTION);
  if (checkedReasons.sale) reasons.push(ReasonCounted.SALE);
  if (checkedReasons.refund) reasons.push(ReasonCounted.REFUND);
  return reasons;
}

export const getCategory = (num_receipts: number) => {
  if (num_receipts <= 2000) {
    return 'A';
  } else if (num_receipts > 2000 && num_receipts <= 5000) {
    return 'B';
  } else if (num_receipts > 5000 && num_receipts <= 10000) {
    return 'C';
  }
  return 'D';
};

export const calculateAmount = (num_receipts: number) => {
  if (num_receipts <= 2000) {
    return 2500;
  } else if (num_receipts > 2000 && num_receipts <= 5000) {
    return 3500;
  } else if (num_receipts > 5000 && num_receipts <= 10000) {
    return 5000;
  }
  return 7000;
};
